import { c as _c } from "react/compiler-runtime";
import { startTransition } from 'react';
import { getENV } from '@libs/common-next';
import css from './tabs.module.scss';
interface Props {
  value: string;
  onChange(value: string): void;
}
export function Tabs(t0) {
  const $ = _c(4);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["Feature flags", "Cache Key", getENV("NEXT_PUBLIC_SITE_PREVIEW") && "Site Preview"].filter(Boolean);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const tabs = t1;
  let t2;
  if ($[1] !== onChange || $[2] !== value) {
    t2 = <nav className={css.tabs}>{tabs.map(tab => <label key={tab} className={css.tab}><span>{tab}</span><input type="radio" name="tabs" checked={value === tab} onChange={() => startTransition(() => onChange(tab))} /></label>)}</nav>;
    $[1] = onChange;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}